import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { downgradeComponent } from '@angular/upgrade/static';
import { SnackBarComponent } from '@core/controls/_snack-bar/snack-bar.component';
import { EpodSpinnerComponent } from '@core/controls/epod-spinner/epod-spinner.component';
import { PermissionsModule } from '@core/directives/permissions/permissions/permissions.module';
import { DeliveryTypeIconComponent } from '../_components/delivery-type-icon/delivery-type-icon.component';
import { PlanerRangeSelectionComponent } from '../_components/planer-range-selection/planer-range-selection.component';
import { AbsenceDayBoxComponent } from './components/absence-day-box/absence-day-box.component';
import { DriverBoxComponent } from './components/driver-box/driver-box.component';
import { EmptyDayBoxComponent } from './components/empty-day-box/empty-day-box.component';
import { OrderBoxComponent } from './components/order-box/order-box.component';
import { PlannerViewComponent } from './components/planner-view/planner-view.component';
import { RoutesBoxCollapsedComponent } from './components/routes-box-collapsed/routes-box-collapsed.component';
import { RoutesBoxComponent } from './components/routes-box/routes-box.component';
import { AddAbsenceForPlannerComponent } from './dialogs/add-absence-for-planner/add-absence-for-planner.component';
import { PlannerManagerService } from './services/planner-manager.service';
import {MatDividerModule} from '@angular/material/divider';
@NgModule({
  declarations: [PlannerViewComponent, DriverBoxComponent, EmptyDayBoxComponent, OrderBoxComponent, RoutesBoxComponent, RoutesBoxCollapsedComponent, AbsenceDayBoxComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,

    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatRippleModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatTooltipModule,
    MatMenuModule,
    MatTableModule,
    MatSlideToggleModule,
    MatDividerModule,
    ClipboardModule,
    FormsModule,
    
    DeliveryTypeIconComponent,
    EpodSpinnerComponent,
    SnackBarComponent, // zmienić nazwę na epod ?
    AddAbsenceForPlannerComponent,
    PlanerRangeSelectionComponent,
    PermissionsModule,
  ],
  providers: [PlannerManagerService]
})
export class DeliveryOrderPlannerModule { }


export function bindPlannerViewToAngularJS(angular: any) {
  angular.directive('plannerViewComponent', downgradeComponent({ component: PlannerViewComponent }));
}
